import React, { ReactNode } from 'react';

type IconButtonProps = {
    onClick: () => void;
    icon: ReactNode;
}

export const IconButton = ({
  onClick,
  icon,
}: IconButtonProps) => {
  return (
    <button
        type='button'
        className='flex h-10 w-10 shrink-0 items-center justify-center rounded bg-white p-2 hover:bg-primary-green-300 hover:cursor-pointer'
        onClick={onClick}
    >
      { icon }
    </button>
  );
};
